import Vue from 'vue';
import ApiService from './api.service';
import JwtService from './jwt.service';
// import router from '@/router';

const AuthenticationService = {
  login(email, password, redirect = '/') {
    return ApiService.create('users/sign_in', { user: { email, password } })
      .then((response) => {
        if (response.data) {
          JwtService.saveToken(response.data.user.token);
          ApiService.setHeader();
        }
      });
  },
  logout() {
    JwtService.destroyToken();
    router.push({ name: 'Login' });
  },
  checkAuthentication(to = '', from, next) {
    if (JwtService.getToken() && !JwtService.isTokenExpired()) {
      ApiService.setHeader();

      if (to.name === 'Login') {
        next({ path: '/' });
      } else {
        next();
      }
    } else {
      JwtService.destroyToken();

      const permittedRoutes = [
        'Login',
      ];

      if (permittedRoutes.includes(to.name)) {
        next();
      } else {
        next({ name: 'Login' });
      }
    }
  },
};

export default AuthenticationService;
